App.DocumentsTable = class {
  constructor(table) {
    this.table = table

    this.loadData           = this.loadData.bind(this);
    this.render             = this.render.bind(this);
    this.renderDetails      = this.renderDetails.bind(this);
    this.renderNotes        = this.renderNotes.bind(this);
    this.renderDownloadIcon = this.renderDownloadIcon.bind(this);
    this.renderDeleteButton = this.renderDeleteButton.bind(this);
  }

  loadData() {
    if (!(this.data === null || this.data === undefined)) {
      return this.data;
    }

    fetch('/file_share/documents', {
        credentials: 'same-origin',
        headers: { "Accept": "application/json; charset=UTF-8" }
      }).
      then((response) => {
        return response.json();
      }).
      then((data) => {
        this.data = data;
      }).
      then(() => { this.render() })

      // TODO - catch an error, do something intelligent
  }

  render() {
    if ($.fn.DataTable.isDataTable(this.table)) { return } // we want to ensure we initalize it just the once

    this.table.DataTable({
      data: this.loadData(),
      "deferRender": true,

      "lengthChange": true,

      "oLanguage": {
        "sSearch": "Filter"
      },

      "columnDefs": [
        {
          "targets": [2],
          "type": "date"
        },
        {
          "targets": [1, 3, 4, 5],
          "searchable": true
        },
        {
          "targets": [1, 2, 3],
          "orderable": true
        },
        {
          "targets": "_all",
          "orderable": false,
          "searchable": false
        }
      ],

      "columns": [
        { data: null, render: this.renderDownloadIcon },
        { data: "file" },
        { data: "added_date" },
        { data: "type" },
        { data: "details", render: this.renderDetails },
        { data: "notes", render: this.renderNotes },
        { data: null, render: this.renderDeleteButton }
      ],

      order: [[2, "desc"]]
    })

    // this is a hack that relies on the { lengthChange: true } being set on the data
    // table. normally that'd get some html like this:
    //
    //   <div class="row">
    //     <div class="col-sm-6">
    //     <div class="dataTables_length" id="DataTables_Table_0_length">
    //       <label>
    //         Show
    //         <select name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" class="form-control input-sm">
    //           <option value="10">10</option><option value="25">25</option>
    //           <option value="50">50</option><option value="100">100</option></select>
    //         entries
    //       </label>
    //     </div>
    //   </div>
    //
    //   <div class="col-sm-6">
    //     <div id="DataTables_Table_0_filter" class="dataTables_filter">
    //       <label>
    //         Filter
    //         <input type="search" class="form-control input-sm" placeholder="" aria-controls="DataTables_Table_0">
    //       </label>
    //     </div>
    //   </div>
    //  </div>
    //
    // since we don't care to render the pagination options, we instead hijack the "_length"
    // div and put a select in there so we can filter by type
    //
    let $length_container = $(`#${this.table.DataTable().table().node().id}_length`) // find it
    $length_container.css("float", "none") // stop it floating right
    $length_container.empty() // clear it out
    $length_container.append( // add our stuff
      $('<label>Filter by Type</label>').
        append(
          $(
            [
              '<select class="form-control input-sm"',
                       'style="width: auto !important; height: 36px; !important;">',

                '<option value="">Any</option>',
                '<option>Appraisals</option>',
                '<option>Certificate of Insurance</option>',
                '<option>General from VMLIP</option>',
                '<option>General to VRSA</option>',
                '<option>Invoice</option>',
                '<option>Member Policy</option>',
                '<option>WC Payroll Audits</option>',
              '</select>'
            ].join('')
          ).
          change((event) => {
            let table = this.table.DataTable()
            table.columns(3).search(event.target.value)
            table.draw()
          })
        )
    )
  }

  renderDetails(data, type, row, meta) {
    if (data) {
      return [
        "<ul>",
          ...data.split(",").map((list_item) => (
            `<li>${list_item}</li>`
          )),
        "</ul>"
      ].join("")
    }
    else {
      return ""
    }
  }

  renderNotes(data, type, row, meta) {
    if (data) {
      if (data.length >= 50) {
        return [
          '<span class="tooltip-icon">',
            `${data}...`,
            '<span class="tooltip">',
              'Notes returned from the file share are truncated to 50 characters, but the contents ',
                'of the full note have been saved.',
            '</span>',
          '</span>'
        ].join('')
      }
      else {
        return data
      }
    }
    else {
      return ""
    }
  }

  renderDownloadIcon(data, type, row, meta) {
    return [
      `<a target="_blank"`,
         `class="btn btn-muted-blue btn-with-icon download no-text" href="${row.download_link}">`,
      '</a>'
    ].join('')
  }

  renderDeleteButton(data, type, row, meta) {
    return row.delete_link;
  }

  addRow(row) {
    let data_table = this.table.DataTable();
    data_table.rows.add([row]);
    data_table.draw();
  }

  removeRow(row) {
    let data_table = this.table.DataTable();
    data_table.row(row).remove();
    data_table.draw();
  }
}

$(document).on('turbo:load', () => {
  if($(".documents.index").length == 0) return;

  $("[data-behavior=documents_data_table]").each(function () {
    let table = new App.DocumentsTable($(this));
    table.loadData();
  })
});

$(document).on('file_share:uploaded', (event) => {
  $("[data-behavior=documents_data_table]").each(function () {
    let table = new App.DocumentsTable($(this));
    table.addRow(event.detail);
  })
});

$(document).on("ajax:success", "[data-behavior=document_delete_link]", function(data, status, xhr) {
  let link_row = $(this).parents("tr");

  $("[data-behavior=documents_data_table]").each(function () {
    let table = new App.DocumentsTable($(this));
    table.removeRow(link_row);
  })
});
